import generer from '@/services/general/genererAdresse';
import genererEntiteCommerciale from '@/services/entiteCommerciale/genererEntiteCommerciale';
import genererEmplacementTechnique
  from '@/services/gabed/emplacement/generer/genererEmplacementTechnique';

export default function genererEmplacementClient() {
  return {
    entiteCommerciale: genererEntiteCommerciale(),
    emplacementTechnique: genererEmplacementTechnique(),
    code: '',
    libelle: '',
    adresseCadastrale: generer(),
    description: '',
    societeId: null,
    agenceId: null,
    actif: true,
    clientId: null,
  };
}
